module.exports = __webpack_public_path__ + "img/flatblack.d422d595.png";